import React from 'react'

import SearchLine from 'containers/SearchLine'

const SearchContent = () => <SearchLine alwaysRender/>

export default SearchContent
